import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AIToolSuggestionsPage from "@/pages/admin/AIToolSuggestionsPage";

export const Route = createFileRoute("/_admin/admin/ai-tool-suggestions")({
  head: () => pageHead("Admin · Ai Tool Suggestions", "AKIVA admin · ai tool suggestions portal.", "/admin/ai-tool-suggestions", true),
  component: AIToolSuggestionsPage,
});
